/** Errores reconocibles del dominio Venta (la UI puede mapear por `instanceof`). */

/**
 * El backend rechazó aplicar la venta porque ya existe con status `voided`.
 * Sucede cuando se reusa un saleId anulado (ej. cobro QR MP → cambiar medio →
 * re-cobrar reusando el saleId pendiente). Es un estado terminal para ese saleId:
 * reintentar con el mismo id siempre falla, así que el checkout debe descartar el
 * saleId pendiente para que el próximo cobro genere uno nuevo.
 *
 * No es "esperado": si llega a surfacear es señal de que algún flujo reusó un
 * saleId anulado, así que se sigue reportando a Sentry para visibilidad.
 */
export class SaleAlreadyVoidedError extends Error {
  constructor(message = 'Esta venta ya fue anulada. Cargala de nuevo para registrarla.') {
    super(message);
    this.name = 'SaleAlreadyVoidedError';
    Object.setPrototypeOf(this, new.target.prototype);
  }
}
